export default {
    name: "Leads",
    meta: {
        icon: "note_add",
        expanded: true,
        auth: true
    },

    departmentName: "Leads",
    finalPagePermision: "Lead",

    children: [
        {

            name: "Lead",
            keywords: ['Lead'],
            permissionName: 'Lead',
            path: "/lead/leadlist",
            meta: {
                icon: "note_add",
                auth: true
            },
            component: require("../component/Lead/leadList.vue"),
            finalPagePermision: "Lead",

        },
        {
            name: "Lead Dashboard",
            path: "/dashboard/leadDashboard",
            permissionName: 'Lead_Dashboard',
            keywords: ['Lead Dashboard'],
            meta: {
                icon: "dashboard",
                auth: true,
            },
            component: require("../component/dashboard/leadDashboard.vue"),
            finalPagePermision: "Lead_Dashboard",
        },
    ]
};


// WEBPACK FOOTER //
// ./src/sidebar/lead.js